export default __webpack_public_path__ + "src/images/packages/cradle-boutique-hotel/920cd544884b3db0f5619662d9b916d1-4.png";